/**
 * optionList
 * 단일 옵션 여부 확인
 */
import SelectNumberLayer from '../layer/SelectNumberLayer';
import InputNumber from '../extra/InputNumber';

export default class PurchaseInnerCart {
  minBuyCnt = 1;

  htTimeout = {};

  constructor() {
    this.welContainer = $('ul[data-role="prchInnerCart"]');

    if (TMON.oApp.sPlatform === 'PW') {
      this.sNumberSelectType = 'input';
    } else {
      this.sNumberSelectType = 'selectLayer';
    }

    this.oSelectNumberLayer = null;

    this.setEvent();
    this.setResultPrice();
  }

  setEvent() {
    // 삭제
    this.welContainer.on('click', 'button[data-role="delInnerCartItem"]', e => {
      TMON.oApp.setStorage('delInnerCartItem', {
        optionNo: $(e.currentTarget)
          .parents('[data-role="wrapInnerCartItem"]')
          .data('optionno'),
      });
    });

    // count - minus
    this.welContainer.on('click', 'button[data-role="prchMinusCount"]', e => {
      TMON.oApp.setStorage('adjInnerCartItemCount', {
        optionNo: $(e.currentTarget)
          .parents('[data-role="wrapInnerCartItem"]')
          .data('optionno'),
        adj: -1,
      });
    });

    // count - plus
    this.welContainer.on('click', 'button[data-role="prchPlusCount"]', e => {
      TMON.oApp.setStorage('adjInnerCartItemCount', {
        optionNo: $(e.currentTarget)
          .parents('[data-role="wrapInnerCartItem"]')
          .data('optionno'),
        adj: 1,
      });
    });

    this.welContainer.on('click', '[data-role="prchOpenCountLayer"]', e => {
      const elCurrentTarget = $(e.currentTarget);
      // count - layer
      if (this.sNumberSelectType === 'selectLayer') {
        // 구매 가능수량 0 일 경우 layer 띄우지 않음
        const { htTargetItem } = TMON.oApp.htStorage.innerCartItems;
        if (htTargetItem.orderDealMax.availableBuyCount === 0) {
          return;
        }

        if (!this.oSelectNumberLayer) {
          this.oSelectNumberLayer = new SelectNumberLayer();
        }
        this.oSelectNumberLayer.open({
          nCount: parseInt(elCurrentTarget.text().replace(/[^0-9]/g, ''), 10),
          nBuyLimitMin: elCurrentTarget.data('mincount'),
          nBuyLimitMax: elCurrentTarget.data('maxcount'),
          callBackFn: nVal => {
            this.setNumberToStorage(elCurrentTarget, nVal);
          },
        });
      }
      // count - input[type=number]
      if (this.sNumberSelectType === 'input') {
        if (!this.oInputNumber) {
          this.oInputNumber = new InputNumber();
        }
        this.oInputNumber.open({
          targetEl: elCurrentTarget,
          nCount: parseInt(elCurrentTarget.text().replace(/[^0-9]/g, ''), 10),
          nBuyLimitMin: elCurrentTarget.data('mincount'),
          nBuyLimitMax: elCurrentTarget.data('maxcount'),
          callBackFn: (welTarget, nVal) => {
            this.setNumberToStorage(welTarget, nVal);
          },
          onOverflowFn: welTarget => {
            this.setOverflowDescription(welTarget);
          },
        });
      }
    });
  }

  setOverflowDescription(welTarget) {
    const nTargetOptionNo = welTarget.attr('data-optionNo');
    const welTargetLayer = $(
      `[data-role=wrapInnerCartItem][data-optionNo=${nTargetOptionNo}]`
    ).find('[data-role=maxBuyOverflowLayer]');
    welTargetLayer.fadeIn();
    if (this.htTimeout[`${nTargetOptionNo}`]) {
      clearTimeout(this.htTimeout[`${nTargetOptionNo}`]);
    }
    this.htTimeout[`${nTargetOptionNo}`] = setTimeout(() => {
      welTargetLayer.fadeOut();
    }, 2000);
  }

  setNumberToStorage(welTarget, nVal) {
    TMON.oApp.setStorage('adjInnerCartItemCount', {
      optionNo: welTarget
        .parents('[data-role="wrapInnerCartItem"]')
        .data('optionno'),
      adj: nVal - parseInt(welTarget.text().replace(/[^0-9]/g, ''), 10),
    });
  }

  clearEvent() {
    this.welContainer.off('click', 'button[data-role="delInnerCartItem"]');
    this.welContainer.off('click', 'button[data-role="prchMinusCount"]');
    this.welContainer.off('click', 'button[data-role="prchPlusCount"]');
    this.welContainer.off('click', '[data-role="prchOpenCountLayer"]');
  }

  update(sStorageKey) {
    if (sStorageKey === 'innerCartItems') {
      const { sAction } = TMON.oApp.htStorage.innerCartItems;

      if (sAction === 'initialize') {
        this.emptyInnerCart();
      } else if (sAction === 'delete') {
        this.deleteInnerCartItem();
      } else if (sAction === 'add') {
        this.addInnerCartItem();
      } else if (sAction === 'updateCount') {
        this.updateInnerCartItemPrice();
      } else if (sAction === 'join') {
        // 복수의 옵션을 합쳐서 하나의 옵션으로 노출할 때 (ex 체크인 체크아웃)
        this.joinInnerCartItems();
      }
      this.setResultPrice();
    }
  }

  emptyInnerCart() {
    this.welContainer.empty();
  }

  addInnerCartItem() {
    const { htTargetItem } = TMON.oApp.htStorage.innerCartItems;

    this.welContainer.append($(this.getListItemHtml(htTargetItem)));
    this.setAmountStatus(htTargetItem);
  }

  deleteInnerCartItem() {
    const { nTargetOptionNo } = TMON.oApp.htStorage.innerCartItems;

    for (let i = 0; i < this.welContainer.length; i += 1) {
      this.welContainer
        .eq(i)
        .find(`li[data-optionno="${nTargetOptionNo}"]`)
        .remove();
    }
  }

  updateInnerCartItemPrice() {
    const {
      nTargetOptionNo,
      htTargetItem,
    } = TMON.oApp.htStorage.innerCartItems;

    for (let i = 0; i < this.welContainer.length; i += 1) {
      this.welContainer
        .eq(i)
        .find(`li[data-optionno="${nTargetOptionNo}"]`)
        .find('[data-role=price_area]')
        .replaceWith(this.getPriceHtml(htTargetItem));
    }
    this.setAmountStatus(htTargetItem);
  }

  joinInnerCartItems() {
    const { sOptionTitle, aList } = TMON.oApp.htStorage.innerCartItems;

    // 묶여진 옵션을 대표할 옵션
    const htItem = {
      optionNo: [],
      optionTitle: sOptionTitle,
      discountAmount: 0,
      originalPrice: 0,
      price: 0,
      count: aList[0].count,
      orderDealMax: Object.assign({}, aList[0].orderDealMax),
    };

    aList.forEach(item => {
      const htDiscountInfo = TMON.oApp.oUtil.getDiscountInfos(item);

      htItem.optionNo.push(item.optionNo);
      htItem.discountAmount += htDiscountInfo.discountAmount;
      htItem.originalPrice += htDiscountInfo.originalPrice;
      htItem.price += htDiscountInfo.price;
    });

    if (this.welContainer.find('li').length > 0) {
      for (let i = 0; i < this.welContainer.length; i += 1) {
        this.welContainer
          .eq(i)
          .find('li')
          .find('[data-role=price_area]')
          .replaceWith(this.getPriceHtml(Object.assign({}, aList[0], htItem)));
      }
    } else {
      for (let i = 0; i < this.welContainer.length; i += 1) {
        this.welContainer
          .eq(i)
          .html($(this.getListItemHtml(Object.assign({}, aList[0], htItem))));
      }
    }

    this.setAmountStatus(Object.assign({}, aList[0], htItem));
  }

  render() {
    // 자동 완성 or localStorage로 접근할 때
    this.welContainer.html(
      TMON.oApp.htStorage.innerCartItems.aList
        .map(htItem => $(this.getListItemHtml(htItem)))
        .join('')
    );
  }

  getDataMaxCount(htItem) {
    if (TMON.htStaticData.isOneTimeOneBuyDeal) return 1;
    const {
      maxPurchasableQtyPerPerson,
    } = TMON.oApp.htStorage.htStaticData.htDealInfo; // 1인당 구매가능수량
    const totalBuyCount = TMON.oApp.getStorage('orderCount').data.totalBuyCount;
    return Math.min(
      Number(maxPurchasableQtyPerPerson) - Number(totalBuyCount),
      htItem.orderDealMax.availableBuyCount
    );
  }

  getListItemHtml(htItem) {
    let { count } = htItem;
    if (htItem.orderDealMax.availableBuyCount === 0) {
      count = 0;
      this.minBuyCnt = 0;
    }
    return `
            <li class="${
              htItem.orderDealMax.soldOut ? 'soldout' : ''
            }" data-role="wrapInnerCartItem" data-optionNo="${htItem.optionNo}">
                <span class="tit">
                  <span>
                    ${htItem.isBundleOnly ? `<strong class="addoption">[추가구매상품] </strong>` : ''}
                    ${TMON.oApp.oUtil.removeStringElement(
                      [
                        htItem.optionTitle,
                        !TMON.htStaticData.bIsDeliveryDeal ||
                        TMON.oApp.htStorage.htStaticData.htDealInfo
                          .isCvsPickupSupported
                          ? ''
                          : '[편의점 픽업 불가]',
                      ].join(''),
                      ['BR']
                    )}
                  </span>
                  ${
                    htItem.unitPrice && htItem.unitPrice.unit
                      ? `<span class="each">(${[
                          htItem.unitPrice.unitSize,
                          htItem.unitPrice.unit,
                        ].join('')}당 ${htItem.unitPrice.unitPrice}원)</span>`
                      : ''
                  }
                  ${TMON.oApp.oTemplate.getStockCount(htItem)}
                </span>
                ${
                  TMON.oApp.htStorage.optionInfo && TMON.oApp.htStorage.optionInfo.isAvailableOptionSelect
                    ? '<button type="button" class="del" data-role="delInnerCartItem"><i class="blind">삭제</i></button>'
                    : ''
                }
                <div class="middle_wrap">
                    ${this.getPriceHtml(htItem)}

                    <div class="amount">
                        <button type="button" data-role="prchMinusCount" data-mincount="${
                          this.minBuyCnt
                        }" class="minus">
                            <i class="blind">수량 감소</i>
                        </button>
                        <label>
                            <strong data-role="prchOpenCountLayer" data-optionNo="${
                              htItem.optionNo
                            }" data-mincount="${
      this.minBuyCnt
    }" data-maxcount="${this.getDataMaxCount(htItem)}">${count}</strong>
                        </label>
                        <button type="button" data-role="prchPlusCount" data-maxcount="${this.getDataMaxCount(
                          htItem
                        )}" class="plus">
                            <i class="blind">수량 증가</i>
                        </button>
                        <div class="pop_tooltip light prch_limit" data-role="maxBuyOverflowLayer" style="display:none">
                            <div class="inner">
                                최대 구매수량은 <span>${TMON.util.numberWithComma(
                                  this.getDataMaxCount(htItem)
                                )}</span>개 입니다.
                            </div>
                        </div>
                    </div>
                </div>
                <span class="prod_avail_count">${TMON.util.numberWithComma(
                  this.getDataMaxCount(htItem)
                )}개 구매 가능</span>
            </li>
        `;
  }

  setAmountStatus = htItem => {
    // const optionNo = typeof htItem.optionNo === 'object' ? htItem.optionNo : htItem.optionNo;
    let welTargetMinusButton;
    let welTargetPlusButton;
    let welTargetAmountText;
    let welTarget;
    let count = htItem.count;

    for (let i = 0; i < this.welContainer.length; i += 1) {
      welTarget = this.welContainer
        .eq(i)
        .find(`li[data-optionNo='${htItem.optionNo}']`);
      welTargetMinusButton = welTarget.find('[data-role=prchMinusCount]');
      welTargetPlusButton = welTarget.find('[data-role=prchPlusCount]');
      welTargetAmountText = welTarget.find('[data-role=prchOpenCountLayer]');

      if (
        this.minBuyCnt === htItem.count ||
        htItem.orderDealMax.availableBuyCount === 0 ||
        TMON.htStaticData.isOneTimeOneBuyDeal
      ) {
        welTargetMinusButton.prop('disabled', true);
        welTargetMinusButton.addClass('disabled');
      } else {
        welTargetMinusButton.prop('disabled', false);
        welTargetMinusButton.removeClass('disabled');
      }
      if (
        htItem.orderDealMax.availableBuyCount === htItem.count ||
        htItem.orderDealMax.availableBuyCount === 0 ||
        TMON.htStaticData.isOneTimeOneBuyDeal
      ) {
        welTargetPlusButton.prop('disabled', true);
        welTargetPlusButton.addClass('disabled');
      } else {
        welTargetPlusButton.prop('disabled', false);
        welTargetPlusButton.removeClass('disabled');
      }
      if (htItem.orderDealMax.availableBuyCount === 0) {
        count = 0;
      }
      welTargetAmountText.html(TMON.util.numberWithComma(count));
    }
  };

  setResultPrice = () => {
    let nSalePrice = 0;
    let nResultPrice = 0;
    const welItem = $('[data-role=prchInnerCart]:first').find('li');
    for (let i = 0; i < welItem.length; i += 1) {
      const isAvailable =
        parseInt(
          $(welItem[i])
            .find('[data-role="prchOpenCountLayer"]')
            .attr('data-maxcount'),
          10
        ) !== 0;
      if (isAvailable) {
        nSalePrice += parseInt(
          $(welItem[i])
            .find('[data-role=price_area]')
            .attr('data-saleprice'),
          10
        );
        nResultPrice += parseInt(
          $(welItem[i])
            .find('[data-role=price_area]')
            .attr('data-resultprice'),
          10
        );
      }
    }
    if (TMON.oApp.sPlatform === 'PW') {
      $('[data-role=purchaseResult] [data-role=salePrice]').html(
        TMON.util.numberWithComma(nSalePrice)
      );
      $('[data-role=purchaseResult] [data-role=resultPrice]').html(
        TMON.util.numberWithComma(nResultPrice)
      );
      if (nSalePrice > 0 && !TMON.htStaticData.isDuplicatedDiscount) {
        $('[data-role=purchaseResult] [data-role=salePriceWrap]').show();
      } else {
        $('[data-role=purchaseResult] [data-role=salePriceWrap]').hide();
      }
      $('[data-role=purchaseResult]').show();
    } else {
      $('#mResultPriceDisplay').html(TMON.util.numberWithComma(nResultPrice));
    }
  };

  getSalePrice = (isDuplicated, bPriceTypeSale, nVisibleSalePrice) => {
    if (isDuplicated && !bPriceTypeSale) {
      return '<span class="discount">(주문 시 추가할인)</span>';
    }

    if (bPriceTypeSale) {
      const salePrice = TMON.util.numberWithComma(nVisibleSalePrice);
      return `<span class="discount">(-<em>${salePrice}</em>원 추가할인)</span>`;
    }

    return '';
  };

  getPriceHtml = htItem => {
    const htDiscountInfos =
      TMON.oApp.htStorage.innerCartItems.sAction === 'join'
        ? htItem
        : TMON.oApp.oUtil.getDiscountInfos(htItem);

    let nVisibleSalePrice = htDiscountInfos.discountAmount;
    let nVisibleOriginalPrice = htDiscountInfos.originalPrice;
    let nVisibleResultPrice = htDiscountInfos.price;

    const { isDuplicated } = htDiscountInfos;
    const bPriceTypeSale =
      htDiscountInfos.viewPaymentDiscountInfoKey !== 'normal' &&
      nVisibleSalePrice > 0;
    const nSalePrice = nVisibleSalePrice * htItem.count;
    const nOriginalPrice = nVisibleOriginalPrice * htItem.count;
    const nResultPrice = nVisibleResultPrice * htItem.count;

    if (TMON.oApp.sPlatform !== 'PW') {
      nVisibleSalePrice = nSalePrice;
      nVisibleOriginalPrice = nOriginalPrice;
      nVisibleResultPrice = nResultPrice;
    }

    const sHtml = `
            <div class="price_area" data-role="price_area" data-saleprice="${
              bPriceTypeSale ? nSalePrice : 0
            }" data-resultprice="${nResultPrice}">
                <div class="price">
                    ${this.getSalePrice(
                      isDuplicated,
                      bPriceTypeSale,
                      nVisibleSalePrice
                    )}
                    <div class="total_price">
                    ${
                      bPriceTypeSale
                        ? `<span class="org line-though"><strong>${TMON.util.numberWithComma(
                            nVisibleOriginalPrice
                          )}</strong>원</span>`
                        : ''
                    }
                    ${`<span class="prmt_discount"><strong>${TMON.util.numberWithComma(
                      nVisibleResultPrice
                    )}</strong>원</span>`}
                    </div>
                </div>
            </div>
        `;
    return sHtml;
  };
}
